var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wtLegend-ctn"},[_c('span',{staticClass:"wtLegend--icon"},[_vm._t("icon")],2),_c('span',{staticClass:"wtLegend--label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }